import { render } from "./InfoPix.vue?vue&type=template&id=62bc2f63"
import script from "./InfoPix.vue?vue&type=script&lang=js"
export * from "./InfoPix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__